export const ROUTES = {
  INDEX: '/',
  ADMIN: '/admin',
  ADMIN_SIGN_IN: '/admin/signin',
  HOME: '/home',
  HISTORY: '/history',
  MESSAGES: '/messages',
  MESSAGE: '/message',
  FAVORITES: '/favorites',
  SETTINGS: '/settings',
  ABOUT_US: '/about-us',
  CONTACT_US: '/contact-us',
  NEW_PASSWORD: '/new-password',
  VERIFY_EMAIL: '/verify-email',
  FORGOT_PASSWORD: '/forgot-password',
  HOT_TOURS: '/tours',
  REGISTER: '/register',
  REQUESTS: '/requests',
  VIEW_REQUEST:'/view_request',
  VIEW_REQUEST_ID:'/view_request/:id',
  REQUESTS_ID: '/requests/:id',
  LOGIN: '/login',
  QUESTIONS: '/questions',
  WELCOME: '/welcome',
  HOW_ITS_WORK: '/how-its-work',
  CHANGE_PASSWORD: '/settings/password',
  DELETE_ACCOUNT: '/settings/delete',
  COUNTDOWN: '/countdown',
  POPULAR_DESTINATIONS: '/tours',
  PRIVACY_POLICY: '/privacy-policy',
  COOKIE_POLICY: '/cookie-policy',
  TERMS_CONDITIONS: '/terms-and-conditions',
  SUGGESTION: '/suggestion',
  SUGGESTION_ID: '/suggestion/:id',
  TOURS_SUGGESTION: '/tours/suggestion',
  TOURS_SUGGESTION_ID: '/tours/suggestion/:id',
  OFFER: '/offer',
  OFFERS: '/offers',
  OFFER_ID: '/offer/:id',
  ADMIN_HOME: '/admin/home',
  ADMIN_QUESTIONS: '/admin/questions',
  ADMIN_REQUESTS: '/admin/requests',
  ADMIN_REQUESTS_OFFER: '/admin/requests/offer',
  ADMIN_REQUESTS_OFFER_ID: '/admin/requests/offer/:id',
  ADMIN_PACKAGES: '/admin/packages',
  ADMIN_HOT_OFFERS: '/admin/hotoffers',
  ADMIN_PROFILE: 'admin/profile',
};
